import { render, staticRenderFns } from "./FieldDate.vue?vue&type=template&id=5341e528&lang=pug&"
import script from "./FieldDate.vue?vue&type=script&lang=ts&"
export * from "./FieldDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports